module.exports = __webpack_public_path__ + "img/huge-table-2024.54094ced.png";